import { render, staticRenderFns } from "./LinkSmallMegaMenu.vue?vue&type=template&id=e8a95472"
import script from "./LinkSmallMegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkSmallMegaMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports